module.exports = __webpack_public_path__ + "img/수업이끝나면2.fd322eeb.png";